import { render } from "./PolitiquesConfidentialite.vue?vue&type=template&id=5b7d6010"
import script from "./PolitiquesConfidentialite.vue?vue&type=script&lang=js"
export * from "./PolitiquesConfidentialite.vue?vue&type=script&lang=js"

import "./PolitiquesConfidentialite.vue?vue&type=style&index=0&id=5b7d6010&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__